import React, { useState } from 'react';
import { Button, Form, Modal } from "react-bootstrap";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useAddPaymentMutation, useEditPaymentMutation } from '../../redux/services/PaymentService';
import { useGetSelectDriversQuery } from '../../redux/services/DriverService';
import { sweetAlert } from '../../utils';
import { responseError } from '../../helpers/responseHandler';
import LoadingButtonWithForm from '../../components/LoadingButtonWithForm';
import SearchSelect from '../../components/SearchSelect';

const PayemnetsCreateModal = ({ show, handleClose, isEdit }) => {
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    const navigate = useNavigate()
    // const { state: { isEdit } } = useLocation()

    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm()

    const [addRequest, { isLoading: addLoading }] = useAddPaymentMutation()
    const [editRequest, { isLoading: editLoading }] = useEditPaymentMutation()

    const { data: data2 } = useGetSelectDriversQuery()
    const drivers = data2?.response?.data




    const onSubmit = async (data) => {
        data['driver_id'] = data?.driver_id?.value > 0 ? data?.driver_id?.value : ''
        if (isEdit) {
            const newForm = { ...data }
            await editRequest({ id: isEdit?.id, newForm }).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })
        } else {
            const newForm = { ...data }
            await addRequest(newForm).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })
        }
    }
    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">Create Payment</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit(onSubmit)} id='driver-status'>
                        <Form.Group className="mb-3">
                            <Form.Label>Select Driver Name:</Form.Label>
                            <Controller
                                name="driver_id"
                                control={control}
                                defaultValue={
                                    (isEdit?.driver_id && isEdit?.driver) ?
                                        (
                                            { label: isEdit?.driver?.full_name, value: isEdit?.driver?.id }
                                        ) :
                                        null
                                }
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <>
                                        <SearchSelect
                                            options={drivers?.map((item) => ({ value: item?.id, label: item?.full_name }))}
                                            field={field}
                                            placeholder={"Select Approved Driver"}
                                        />
                                        {errors.driver_id && <div className="invalid-feedback d-block">This field is required</div>}
                                    </>

                                )}
                            />
                        </Form.Group>

                        {/* Payment Date */}
                        <Form.Group className="mb-3">
                            <Form.Label>Payment Date:</Form.Label>
                            <Controller
                                name="date"
                                control={control}
                                defaultValue={isEdit?.date || ''}
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <Form.Control
                                        {...field}
                                        type="date" placeholder="Enter payment date"
                                        isInvalid={errors.date}
                                    />
                                )}
                            />
                        </Form.Group>

                        {/* Payment Method */}
                        <Form.Group className="mb-3">
                            <Form.Label>Payment Method:</Form.Label>
                            <Controller
                                name="method"
                                control={control}
                                defaultValue={isEdit?.method || ''}
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <Form.Control
                                        {...field}
                                        type="text" placeholder="Enter payment method"
                                        isInvalid={errors.method}
                                    />
                                )}
                            />
                        </Form.Group>

                        {/* Payment Detail */}
                        <Form.Group className="mb-3">
                            <Form.Label>Payment Detail:</Form.Label>
                            <Controller
                                name="description"
                                control={control}
                                defaultValue={isEdit?.description || ''}
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <Form.Control
                                        {...field}
                                        type="text" placeholder="Enter payment details"
                                        isInvalid={errors.description}
                                    />
                                )}
                            />
                        </Form.Group>

                        {/* Payment Amount */}
                        <Form.Group className="mb-3">
                            <Form.Label>Payment Amount:</Form.Label>
                            <div className="input-group align-items-center">
                                <span className="input-group-addon">$</span>
                                <Controller
                                    name="amount"
                                    control={control}
                                    defaultValue={isEdit?.amount || ''}
                                    rules={{
                                        required: true
                                    }}
                                    render={({ field }) => (
                                        <Form.Control
                                            {...field}
                                            type="number" placeholder="Enter expense amount"
                                            isInvalid={errors.amount}
                                        />
                                    )}
                                />
                            </div>
                        </Form.Group>


                    </Form>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <LoadingButtonWithForm
                        isLoading={editLoading ? editLoading : addLoading}
                        name="Save"
                        form="driver-status"
                    />
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default PayemnetsCreateModal;